import React from 'react'
import { Typography } from '@material-ui/core'

const AttentionTab = ({ items, onSwitchTab }) => {
  if (items.length === 0) {
    return <Typography variant="body2" color="textSecondary" style={{ padding: 24, textAlign: 'center' }}>No estimate context needs attention.</Typography>
  }
  return items.map((item, idx) => {
    const dotColor = item.severity === 'blocking' ? 'var(--risk)' : item.severity === 'attention' ? 'var(--warn)' : 'var(--info)'
    return (
      <div key={idx} style={{ display: 'flex', gap: 10, padding: '10px 0', borderBottom: '1px solid var(--line-1, #eee)', alignItems: 'flex-start' }}>
        <span style={{ width: 8, height: 8, borderRadius: '50%', background: dotColor, flexShrink: 0, marginTop: 6 }} />
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: 13, fontWeight: 500 }}>{item.title}</div>
          {(item.parent_label || item.waiting_on) && (
            <div style={{ fontSize: 11, color: 'var(--ink-3)', marginTop: 2 }}>
              {item.parent_label || item.waiting_on}
            </div>
          )}
          {item.action_label && (
            <a
              style={{ fontSize: 12, color: 'var(--brand, #1976d2)', cursor: 'pointer', fontWeight: 600, marginTop: 2, display: 'inline-block' }}
              onClick={() => {
                const tabMap = { blocker: 'blockers', task: 'tasks', decision: 'decisions', review_event: 'reviews', note: 'notes', conversation: 'conversations' }
                onSwitchTab(tabMap[item.object_type] || 'attention')
              }}
            >
              {item.action_label} {'\u203A'}
            </a>
          )}
        </div>
      </div>
    )
  })
}

export default AttentionTab
